import React from 'react';
import Highlight, { HighlightValueFormatType } from 'components/Highlight';
import QueryRetryWrapper from 'components/QueryRetryWrapper';
import { getData } from 'utils/functions';

interface HighlightQueryProps {
  clientID: string;
  globalFilter: any;
  labels: Array<string>;
  query: any;
  valueFormat: HighlightValueFormatType;
}

const HighlightQuery: React.FC<HighlightQueryProps> = ({
  clientID,
  globalFilter,
  labels,
  query,
  valueFormat
}) => (
  <QueryRetryWrapper
    query={query}
    variables={{
      clientID: clientID,
      globalFilter: globalFilter
    }}
    fetchPolicy="cache-first"
  >
    {({ data }) => {
      const { amountDelta: percentage, amount: value } = getData(data);

      return (
        <Highlight
          labels={labels}
          percentage={percentage === null ? '--' : percentage}
          value={value}
          valueFormat={valueFormat}
        />
      );
    }}
  </QueryRetryWrapper>
);

export default HighlightQuery;
